import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs))
}

export const loginPageConfig = {
    fields: [
        {
            name: "email",
            label: "Email address",
            type: "email",
            required: true,
            placeholder: "Enter your Email Address",
            inputBackground: "#ffffff",
            inputColor: "#111827",
            borderColor: "#d1d5db",
            borderRadius: "0.5rem",
            labelColor: "#111827",
            padding: "0.75rem",
        },
        { 
            name: "password",
            label: "Password",
            type: "password",
            required: true,
            placeholder: "Enter Your Password",
            inputBackground: "#ffffff",
            inputColor: "#111827",
            borderColor: "#d1d5db",
            borderRadius: "0.5rem",
            labelColor: "#111827",
            padding: "0.75rem",
        },
    ],
    form: {
        background: "#ffffff",
        borderRadius: "0",
        boxShadow: "none",
        border: "none",
        padding: "2rem",
        maxWidth: "28rem",
    },
}

export const registerPageConfig = {
    fields: [
        {
            name: "first_name",
            label: "First Name",
            type: "text",
            required: true,
            placeholder: "Enter your First Name",
        },
        {
            name: "last_name",
            label: "Last Name",
            type: "text",
            required: true,
            placeholder: "Enter your Last Name",
        },
        {
            name: "email",
            label: "Email address",
            type: "email",
            required: true,
            placeholder: "Enter your Email Address",
        },
    ],
    form: {
        background: "#ffffff",
        borderRadius: "0",
        boxShadow: "none",
        border: "none",
        padding: "2rem",
        maxWidth: "28rem",
    },
}